import React from 'react'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'
import InputRadio from '../../../Components/InputRadio'
import { PrefixUrlData } from '@src/data/UtmGenerator'

import * as Styled from './PrefixURL.styled'

const PrefixUrl = () => {
  const { getProtocolName, protocol } = useHTTPContext()

  return (
    <Styled.Container>
      {PrefixUrlData.map(item => (
        <InputRadio
          key={item.id}
          name={item.name}
          checked={protocol === item.value}
          value={item.value}
          label={item.label}
          onChange={getProtocolName}
        />
      ))}
    </Styled.Container>
  )
}

export default PrefixUrl
